import './AboutUs.css';
import { useEffect } from 'react';

function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-us-page">
      {/* Header Space */}
      <div className="header-spacer"></div>

      {/* About Us Section */}
      <section className="about-us-section">
        <div className="container">
          <div className="about-us-content">
            <div className="about-us-text">
              <h1 className="about-us-title">مركز آفاق</h1>
              <h2 className="about-us-subtitle">للتعليم المستقبلي</h2>
              <h3 className="about-us-slogan">ندربك لتستعد للمستقبل</h3>
              
              <p className="about-us-description">
                مركز آفاق للتعليم المستقبلي متخصص في الاستشارات والتدريب، مرخَّص من وزارة التربية والتعليم بدولة الإمارات العربية المتحدة عام (2005م). انطلق المركز من الحاجة الماسّة إلى تطوير الكوادر البشرية، وأحداث نقلة نوعية في طريقة وأدوات ووسائل إنجاز الأعمال الإدارية، وتحسين السلوك القيادي، واستشراف وتعلُّم مهارات المستقبل؛ لمواكبة الثورة الصناعية الرابعة، التي تتطلّب تطويرًا متقنًا لقدرات الموارد البشرية، يمكّنهم من الاستعداد للمستقبل بجدارة.
              </p>

              <p className="about-us-description about-us-description-secondary">
                تقديم خدمات تدريبية واستشرافية للجميع بطرق احترافية تساهم في الارتقاء بالكوادر البشرية بالشراكة مع القطاعات العامة والخاصة وإكسابهم مهارات المستقبل ليكونوا أكثر استعداداً له، ونسعى إلى أن تكون مؤسستنا الأفضل في أنشطتها ومبادراتها وبرامجها ومرافقها.
              </p>
            </div>
            <div className="about-us-image">
              <img src="/uni7-768x384.jpg" alt="من نحن" />
            </div>
          </div>
        </div>
      </section>

      {/* Vision, Mission, and Goals Section */}
      <section className="vision-mission-section">
        <div className="container">
          <div className="vmg-grid">
            {/* Vision */}
            <div className="vmg-card">
              <div className="vmg-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 16v-4M12 8h.01"/>
                </svg>
              </div>
              <h3 className="vmg-title">رؤيتنــــا</h3>
              <p className="vmg-description">
                إحداث فرق نوعي ومستدام في واقع ومستقبل الأفراد والمؤسسات
              </p>
            </div>

            {/* Mission */}
            <div className="vmg-card">
              <div className="vmg-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
              </div>
              <h3 className="vmg-title">رســالتنا</h3>
              <p className="vmg-description">
                تقديم خدمات تدريبية واستشرافية للجميع بطرق احترافية تساهم في الارتقاء بالكوادر البشرية بالشراكة مع القطاعات العامة والخاصة وإكسابهم مهارات المستقبل ليكونوا أكثر استعداداً له، ونسعى إلى أن تكون مؤسستنا الأفضل في أنشطتها ومبادراتها وبرامجها ومرافقها
              </p>
            </div>

            {/* Goals */}
            <div className="vmg-card">
              <div className="vmg-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="3"/>
                  <circle cx="12" cy="12" r="7"/>
                  <circle cx="12" cy="12" r="10"/>
                </svg>
              </div>
              <h3 className="vmg-title">مهمتنــــا</h3>
              <p className="vmg-description">
                تمكين الجميع من مهارات المستقبل ومواكبة متطلباته وأمتلاك مفعد في طاقة التغيير
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Goals Details Section */}
      <section className="goals-details-section">
        <div className="container">
          <div className="goals-content">
            <div className="goals-text">
              <h2 className="goals-main-title">أهدَافُنــــــا</h2>
              <ul className="goals-list">
                <li className="goal-item">
                  <span className="goal-number">1</span>
                  <p>المساهمة في الارتقاء وتنمية المؤسسات الحكومية والأهلية والتجارية من خلال تطوير وتأهيل الكوادر العاملة فيها.</p>
                </li>
                <li className="goal-item">
                  <span className="goal-number">2</span>
                  <p>تقديم البرامج والدورات التدريبية باستخدام وتطبيق طرق التدريب الحديثة.</p>
                </li>
                <li className="goal-item">
                  <span className="goal-number">3</span>
                  <p>تقديم الاستشارات المُتخصصة في مجـال الأعمال والمشاريع بمهنية عالية.</p>
                </li>
                <li className="goal-item">
                  <span className="goal-number">4</span>
                  <p>تعميق الأثر التدريبي لتحقيق أعلى العائدات من خلال اختيار المدربين المحترفين وتوفير البيئة التدريبية الملائمة والمحفزة.</p>
                </li>
                <li className="goal-item">
                  <span className="goal-number">5</span>
                  <p>التشجيع على المسؤولية الوطنية من خلال نشر وتطبيق ثقافة التدريب للجميع.</p>
                </li>
                <li className="goal-item">
                  <span className="goal-number">6</span>
                  <p>التطوير الدائم والتحسين المستمر للخدمات التي نُقــــدمها بما يواكب متطلبات الثورة المعرفية.</p>
                </li>
                <li className="goal-item">
                  <span className="goal-number">7</span>
                  <p>التدريب والتطوير المُستمر لفريق العمل لاستدامة تميـــــزه.</p>
                </li>
              </ul>
            </div>
            <div className="goals-image">
              <img src="/goals.jpg" alt="أهدافنا" />
            </div>
          </div>
        </div>
      </section>

      {/* Strategy Section */}
      <section className="strategy-section">
        <div className="container">
          <div className="strategy-content">
            <div className="strategy-image">
              <img src="/18.jpg" alt="استراتيجياتنا" />
            </div>
            <div className="strategy-text">
              <h2 className="strategy-main-title">استراتيجيـــاتنا المُستقبلية</h2>
              <ul className="strategy-list">
                <li className="strategy-item">
                  <div className="strategy-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 11l3 3L22 4"/>
                      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                    </svg>
                  </div>
                  <p>تطوير خدماتنــــــا بما يحقــــق رضـــا وثقـــة العملاء.</p>
                </li>
                <li className="strategy-item">
                  <div className="strategy-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 11l3 3L22 4"/>
                      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                    </svg>
                  </div>
                  <p>المساهمة الفاعلة في تنمية القطاع العام والخاص من خلال التوجيه والإرشاد وتقديم الاستشارات والتدريب المحترف لهم.</p>
                </li>
                <li className="strategy-item">
                  <div className="strategy-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 11l3 3L22 4"/>
                      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                    </svg>
                  </div>
                  <p>زيادة الخدمات التي نقدمها والفئة المستهدفة كمــاً ونـــوعـــاً.</p>
                </li>
                <li className="strategy-item">
                  <div className="strategy-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 11l3 3L22 4"/>
                      <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                    </svg>
                  </div>
                  <p>التشبيك وبناء الشراكات وتبادل الخبرات مع المؤسسات الدولية ذات العلاقة بمجالات عملنا.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* What Makes Us Special Section */}
      <section className="special-section">
        <div className="container">
          <div className="special-content">
            <div className="special-image">
              <img src="/66666.jpg" alt="ما يميزنا" />
            </div>
            <div className="special-text">
              <h2 className="special-main-title">ما يُميــــزنا</h2>
              <ul className="special-list">
                <li className="special-item">
                  <span className="special-icon">✓</span>
                  <p>نواكب الحداثة والتطور في الآليات والوسائل والأدوات التدريبية لضمان أعلى العوائد التدريبية.</p>
                </li>
                <li className="special-item">
                  <span className="special-icon">✓</span>
                  <p>(15) عاماً من الخبرة المتراكمة مكنتنا من الريادة في خدماتنا.</p>
                </li>
                <li className="special-item">
                  <span className="special-icon">✓</span>
                  <p>طاقم عمل مُدرب ومؤهل متنوع الجنسيات واللغات لتقديم أفضل الخدمات التدريبية والاستشارية.</p>
                </li>
                <li className="special-item">
                  <span className="special-icon">✓</span>
                  <p>مؤسستنا معتمدة محلياً  في الخدمات التي نقدمها والشهادات التي نمنحها.</p>
                </li>
                <li className="special-item">
                  <span className="special-icon">✓</span>
                  <p>نصمم خدماتنا التدريبية باحترافية تتوافق مع متطلبات العملاء والشركاء الحالية والمستقبلية.</p>
                </li>
                <li className="special-item">
                  <span className="special-icon">✓</span>
                  <p>نتحمل مسؤوليتنا الاجتماعية ونساند مؤسساتنا الحكومية في العمل على توفير التدريب والتعليم للجميع.</p>
                </li>
                <li className="special-item">
                  <span className="special-icon">✓</span>
                  <p>قيادة إماراتية حكيمة للمؤسسة تسعى لتحقيق المصالح الوطنية والنهضة المجتمعية.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="values-main-title">قيمـــنا</h2>
          <div className="values-grid">
            {/* Value 1 */}
            <div className="value-card">
              <div className="value-image">
                <img src="/c1-1.jpg" alt="الإبداع والجودة" />
              </div>
              <div className="value-content">
                <h3 className="value-title">الإبداع والجودة</h3>
                <p className="value-description">
                  نعمل وفق معايير وممارسات مميزة تراعي مواصفات الجودة العالمية في الخدمات التي نقدمها بإبداع
                </p>
              </div>
            </div>

            {/* Value 2 */}
            <div className="value-card">
              <div className="value-image">
                <img src="/c2-1.jpg" alt="الابتكار والتنوع" />
              </div>
              <div className="value-content">
                <h3 className="value-title">الابتكار والتنوع</h3>
                <p className="value-description">
                  نبتكر أفكار ونمارس نشر ثقافة حلول مبتكرة تعزز بالمؤسسات والأفراد ونساهم في تحقيق المزيد من قيمة خدمات مميزة
                </p>
              </div>
            </div>

            {/* Value 3 */}
            <div className="value-card">
              <div className="value-image">
                <img src="/c3-1.jpg" alt="الاستعداد للمستقبل" />
              </div>
              <div className="value-content">
                <h3 className="value-title">الاستعداد للمستقبل</h3>
                <p className="value-description">
                  نطلـــــ بمبادرات للمستقبل بتروي وشمولية لتهيئة مواكبة للتحولات
                </p>
              </div>
            </div>

            {/* Value 4 */}
            <div className="value-card">
              <div className="value-image">
                <img src="/c4-1.jpg" alt="المسؤولية الاجتماعية" />
              </div>
              <div className="value-content">
                <h3 className="value-title">المسؤولية الاجتماعية</h3>
                <p className="value-description">
                  نسعى لتمكين الأفراد بالمهارات من خلال خبر وتجربة محلية وعالمية والتدريب والتأهيل وتنمية المجتمع
                </p>
              </div>
            </div>

            {/* Value 5 */}
            <div className="value-card">
              <div className="value-image">
                <img src="/c5-1.jpg" alt="الحداثة والمعاصرة" />
              </div>
              <div className="value-content">
                <h3 className="value-title">الحداثة والمعاصرة</h3>
                <p className="value-description">
                  نبتكر أفكار ونمارس نشر ثقافة حلول مبتكرة تعزز بالمؤسسات والأفراد ونساهم في تحقيق المعاصر والمعلومات
                </p>
              </div>
            </div>

            {/* Value 6 */}
            <div className="value-card">
              <div className="value-image">
                <img src="/c6-1.jpg" alt="التطوير الدائم" />
              </div>
              <div className="value-content">
                <h3 className="value-title">التطوير الدائم</h3>
                <p className="value-description">
                  نطور كوادرنا المهنية بشكل دائم لتقديم ضمانا بطريقة احترافية وفق أفضل الممارسات والمعلومات
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
